export default __webpack_public_path__ + "static/media/Elemica.a06a9761.png";